import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import classes from "./Breadcrumb.module.css";

const Breadcrumb = ({
  items = [],
  separator = ">",
  className = "",
  onItemClick,
  lastItem,
  isLoading = false,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const breadcrumbItems =
    items.length > 0 ? items : generateBreadcrumbFromRoute(location.pathname);

  const handleItemClick = (item, index) => {
    if (item.label?.toLowerCase() === "edit") {
      const targetIndex = index - 1;
      const targetItem = breadcrumbItems[targetIndex];

      if (targetItem?.path) {
        navigate(targetItem.path);
      }
      return;
    }

    if (onItemClick) {
      onItemClick(item, index);
    } else if (item.path && index < breadcrumbItems.length - 1) {
      navigate(item.path);
    }
  };

  return (
    <nav
      className={`${classes.breadcrumb} ${className}`}
      aria-label="Breadcrumb"
    >
      <ol className={classes.breadcrumbList}>
        {breadcrumbItems.map((item, index) => (
          <li key={index} className={classes.breadcrumbItem}>
            {index > 0 && (
              <span className={classes.separator} aria-hidden="true">
                {separator}
              </span>
            )}
            <span
              className={`${classes.breadcrumbLink} ${
                index === breadcrumbItems.length - 1
                  ? classes.active
                  : classes.inactive
              }`}
              onClick={() => !isLoading && handleItemClick(item, index)}
              role={index < breadcrumbItems.length - 1 ? "button" : undefined}
              tabIndex={index < breadcrumbItems.length - 1 ? 0 : undefined}
            >
              {index === breadcrumbItems.length - 1 && lastItem
                ? lastItem
                : item.label}
            </span>
          </li>
        ))}
      </ol>
    </nav>
  );
};

// Helper function to generate breadcrumb from route
const generateBreadcrumbFromRoute = (pathname) => {
  const pathSegments = pathname.split("/").filter(Boolean);
  const breadcrumbItems = [];

  // Always start with Dashboard
  breadcrumbItems.push({
    label: "Dashboard",
    path: "/",
  });

  // Map common routes
  const routeMap = {
    "user-management": "Users",
    "inventory-management": "Inventory",
    "profile-settings": "Profile Settings",
  };

  pathSegments.forEach((segment, index) => {
    const path = "/" + pathSegments.slice(0, index + 1).join("/");
    const label =
      routeMap[segment] ||
      segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, " ");

    breadcrumbItems.push({
      label,
      path: index === pathSegments.length - 1 ? null : path,
    });
  });

  return breadcrumbItems;
};

export default Breadcrumb;
